<script lang="ts" setup>
withDefaults(
  defineProps<{
    imagePath?: string | null
    isBrand?: boolean
    isCategory?: boolean
    link?: string | null
    name: string
  }>(),
  { imagePath: null, isBrand: false, isCategory: false, link: null }
)
</script>

<template>
  <NuxtLink
    class="
      flex cursor-pointer items-center justify-between border-b border-solid border-[#e2e2e2]
      p-3 text-main-dark !no-underline transition-colors
      hover:bg-main-gray-low
    "
    :to="link"
  >
    <div class="flex items-center">
      <img v-if="isBrand" v-lazy="imagePath" alt="brand" loading="lazy">
      <SvgIcon v-else-if="isCategory" class="!size-6" name="outlined/cats" />
      <SvgIcon v-else class="!size-6" name="outlined/new-search" />

      <span class="ml-3 block text-sm tracking-[-0.01em]">
        {{ name }}
      </span>
    </div>

    <SvgIcon class="!size-6" name="outlined/arrow-next" />
  </NuxtLink>
</template>
